(function ($, angular, _, window) {
    'use strict';

    window.THF.Angular.LiveQuoteTool.directive('thfFieldPhoneNumber', ['$timeout', '$sce', function ($timeout, $sce) {
        var link = function (scope, el) {
            scope.icons = {
                single: { src: window.THF.SiteSettings.svgSprite+'#ui-single', viewBox: '0 0 20 26' },
                couple: { src: window.THF.SiteSettings.svgSprite+'#ui-couple', viewBox: '0 0 40 26' },
                family: { src: window.THF.SiteSettings.svgSprite+'#ui-family', viewBox: '0 0 40 23.99' },
                singleParent: { src: window.THF.SiteSettings.svgSprite+'#ui-single-parent', viewBox: '0 0 27.83 26' },
                tooltip: { src: window.THF.SiteSettings.svgSprite+'#ui-tooltip', viewBox: '0 0 32 32' },
                checkboxDefault: { src: window.THF.SiteSettings.svgSprite+'#ui-checkbox-default', viewBox: '0 0 32 32.01' },
                checkboxChecked: { src: window.THF.SiteSettings.svgSprite+'#ui-checkbox-selected', viewBox: '0 0 32 32.01' },
                radialDefault: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-default', viewBox: '0 0 32 32.01' },
                radialChecked: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-filled', viewBox: '0 0 32 32.01' },
                time: { src: window.THF.SiteSettings.svgSprite+'#ui-request-appointment', viewBox: '0 0 32 31.99' },
                add: { src: window.THF.SiteSettings.svgSprite+'#ui-add', viewBox: '0 0 32 32' },
                remove: { src: window.THF.SiteSettings.svgSprite+'#ui-not-applicable', viewBox: '0 0 19.98 19.94' },
                right: { src: window.THF.SiteSettings.svgSprite+'#ui-right', viewBox: '0 0 11.99 22.52' },
                tick: { src: window.THF.SiteSettings.svgSprite+'#ui-covered', viewBox: '0 0 20.01 15.93' },
                invalid: { src: window.THF.SiteSettings.svgSprite+'#ui-not-applicable', viewBox: '0 0 19.98 19.94' },
                edit: { src: window.THF.SiteSettings.svgSprite+'#ui-edit', viewBox: '0 0 31.98 32' },
                andSymbol: { src: window.THF.SiteSettings.svgSprite+'#ui-and', viewBox: '0 0 24.01 28' },
                down: { src: window.THF.SiteSettings.svgSprite+'#ui-down', viewBox: '0 0 22.52 11.99' },
                up: { src: window.THF.SiteSettings.svgSprite+'#ui-up', viewBox: '0 0 22.52 11.99' }
            };
            
            scope.isValid = function(validationArray, key, type) {
                if( typeof validationArray === 'undefined' ) {
                    return true;
                }
                    
                if( typeof validationArray[key] === 'undefined' ) {
                    return true;
                }
                
                

                if(typeof type !== 'undefined' && typeof validationArray[key].details !== 'undefined') {

                    if(validationArray[key].details instanceof Array) {
                        var validationDetails = validationArray[key].details.filter(function(item) {
                            return item.type === type;
                        });
                        if(validationDetails.length > 0) {
                            var detail = validationDetails[0];
                            
                            return detail.result;
                        }
                    }
                    
                    return false;
                }
                else {
                    return validationArray[key].result;
                }
                    
                    
                return true;
            };

            scope.labelIdentifier = uuidv4();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');

            scope.isUpdating = false;

            scope.fieldModel = [];
            scope.activeTypeOptions = [];
            scope.buttonState = {
                'add': {
                    'show': true
                },
                'remove': {
                    'show': true
                }
            };


            // Add all fields to the first select.
            // When adding next select remove the fields from the previously selected dropdowns that are not selected and add them to this one.
            // Only add new the items that are not in the previous selects.
            //

            scope.mask = {
                mobile: '9999 999 999',
                home: '(99) 9999 9999',
                office: '(99) 9999 9999'
            };

            scope.typeOptions = {
                mobile: {label: 'Mobile', value: 'mobile'},
                home: {label: 'Home', value: 'home'},
                office: {label: 'Work', value: 'office'}
            };

            scope.addType = function ($event) {
                $event.preventDefault();
                addType();
            };

            scope.removeType = function ($event, $index) {
                $event.preventDefault();
                removeType($index);
            };

            scope.updateTypeOptions = function () {
                updateTypeOptions();
            };

            scope.skipModelUpdate = false;

            scope.$watch('fieldModel', function () {
                var modelData = [];
                for (var k = 0; k < scope.fieldModel.length; k++) {
                    modelData.push({
                        'type': scope.fieldModel[k].type,
                        'value': scope.fieldModel[k].value
                    });
                }

                scope.skipModelUpdate = true;
                scope.model[scope.field.name] = modelData;
            }, true);

            scope.$watch('model.' + scope.field.name, function (newValue, oldValue) {
                updateButtonStates();
                if (!scope.skipModelUpdate) {
                    updateFormModel();
                    updateTypeOptions();
                }
                else {
                    scope.skipModelUpdate = false;
                }
                
                if(newValue.length != oldValue.length) {
                    updateTypeOptions();
                }
            }, true);


            updateFormModel();
            if (scope.fieldModel.length === 0) {
                addType();
            }


            function uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                    return v.toString(16);
                });
            }

            function updateFormModel() {
                if (
                    typeof scope.model[scope.field.name] !== 'undefined' &&
                    scope.model[scope.field.name] instanceof Array
                ) {
                    scope.fieldModel = scope.model[scope.field.name];
                    updateTypeOptions();
                    updateButtonStates();
                }
            }


            function applyCustomSelect() {
                $timeout(function () {
                    $('select', el).selectpicker({
                        noneSelectedText: "Please select", template: {
                            caret: '<span class="caret">' +
                            '<svg class="icon icon-closed" viewBox="'+scope.icons.up.viewBox+'"><use xlink:href="'+scope.icons.up.src+'"></use></svg>' +
                            '<svg class="icon icon-open" viewBox="'+scope.icons.down.viewBox+'"><use xlink:href="' + scope.icons.down.src+ '"></use></svg>' +
                            '</span>'
                        }
                    });
                    $('select', el).selectpicker('refresh');
                });
            }

            function addType() {
                var typeOptionsInUse = usedTypeOptions();
                var nextItem = _.first(_.filter(scope.typeOptions, function (i) {
                    return ( typeOptionsInUse.indexOf(i.value) === -1 );
                }));
                if (scope.fieldModel.length < getMaxItemCount()) {
                    scope.fieldModel.push({
                        type: nextItem.value,
                        value: ''
                    });
                    var options = scope.typeOptions;
                    scope.activeTypeOptions.push(options);

                    updateTypeOptions();
                }
                updateButtonStates();
            }

            function removeType($index) {
                scope.fieldModel.splice($index, 1);
                scope.activeTypeOptions.splice($index, 1);
                updateTypeOptions();
                updateButtonStates();
            }

            function updateButtonStates() {
                scope.buttonState.add.show = ( scope.fieldModel.length < getMaxItemCount() );
                scope.buttonState.remove.show = ( scope.fieldModel.length > 1 );
            }

            function usedTypeOptions() {
                var result = [];
                for (var idxItem = 0; idxItem < scope.fieldModel.length; idxItem++) {
                    if (scope.fieldModel[idxItem].type != '') {
                        result.push(scope.fieldModel[idxItem].type);
                    }
                }
                return result;
            }

            function updateTypeOptions() {
                var typeOptionsInUse = usedTypeOptions();
                var itemType;
                for (var idxItem = 0; idxItem < scope.fieldModel.length; idxItem++) {
                    itemType = scope.fieldModel[idxItem].type;
                    scope.activeTypeOptions[idxItem] = _.filter(scope.typeOptions, function (o) {
                        return (itemType == o.value || _.indexOf(typeOptionsInUse, o.value) === -1);
                    });
                }
                applyCustomSelect();
            }

            function getMaxItemCount() {
                return Object.keys(scope.typeOptions).length;
            }
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'field': '=',
                'validation': '=',
                'model': '=',
                'focus': '&',
                'blur': '&'
            },
            'link': link, 
            'templateUrl': function () {
                return THF.Utility.Location.cacheBustUrl('/static/views/live-quote-tool/fields/phoneNumber.html');
            }
        };
    }]);
})(jQuery, angular, _, window);
